import Helper from './Helper';

class FrontpageTabs {
  constructor() {

    this.tabs = document.querySelectorAll('.js-frontpage-tabs');

    if (this.tabs) {
      this.bindCreateTabs()
    }
  }

  bindCreateTabs(){
    this.tabs.forEach(tab => {

      let navTabs = tab.cloneNode(true);
      navTabs.classList.add('ns-tab-container__tabs-nav');

      tab.insertAdjacentHTML('beforebegin', navTabs.outerHTML);

      document.querySelectorAll('.ns-tab-container__tabs-nav .ns-tab-container__tabs-item').forEach((item, index) => {

        document.querySelectorAll('.ns-tab-container__tabs-nav .ns-tab-container__tabs-item:first-child').forEach(firstChild => {
          firstChild.classList.add('ns-nav-active');
        });
        document.querySelectorAll('.ns-tab-container__tabs .ns-tab-container__tabs-item:first-child').forEach(firstChild => {
          firstChild.classList.add('ns-tab-active');
        });

        item.addEventListener('click', () => {
          let items = '';

          if(Helper.isDesktop()){
            items = document.querySelectorAll('.ns-tab-container__tabs:not(.ns-tab-container__tabs-nav) .ns-tab-container__tabs-item');
            let itemsNav = document.querySelectorAll('.ns-tab-container__tabs-nav .ns-tab-container__tabs-item');
            itemsNav.forEach(itemNav => {
              itemNav.classList.remove("ns-nav-active");
            });
            itemsNav[index].classList.add("ns-nav-active");
          } else {
            items = document.querySelectorAll('.ns-tab-container__tabs-nav .ns-tab-container__tabs-item');
          }

          items.forEach(item => {
            item.classList.remove("ns-tab-active");
          });
          items[index].classList.add("ns-tab-active");
        });
      });
    });

  }

}

export default FrontpageTabs;
